import styled from "styled-components";

// KbArticle.css reads the `--sabo-*` palette variables and declares fallbacks
// on `.sabo-article` at specificity 0,1,0. `&&` lifts this rule to 0,2,0 so
// the theme tokens win regardless of stylesheet injection order.
export const KbArticleRoot = styled.div`
  && {
    --sabo-surface: ${({ theme }) => theme.articleSurface};
    --sabo-text: ${({ theme }) => theme.articleText};
    --sabo-text-muted: ${({ theme }) => theme.articleTextMuted};
    --sabo-accent: ${({ theme }) => theme.articleAccent};
    --sabo-accent-light: ${({ theme }) => theme.articleAccentLight};
    --sabo-border: ${({ theme }) => theme.articleBorder};
    --sabo-rule: ${({ theme }) => theme.articleRule};
    --sabo-section-num: ${({ theme }) => theme.articleSectionNum};
  }
`;
